var appointments = {};
appointments.container = [];
appointments.navigation = [];
appointments.bookButton = [];
appointments.expectButton = [];
appointments.searchButton = [];
appointments.changeLocationButton = [];
appointments.localeSwitch = [];
appointments.zipInput = [];
appointments.bookTab = [];
appointments.expectTab = [];
appointments.stores = [];
appointments.storeLocationTemplate = [];
appointments.storeLocationsContainer = [];
appointments.contactForm = [];
appointments.contactFooter = [];
appointments.locationSearch = [];
appointments.locationsList = [];
appointments.confirmation = [];
appointments.nextStep = [];
appointments.submitButton = [];
appointments.sliderContainer = [];
appointments.selectDresses = [];
appointments.selectedDresses = [];
appointments.sliderTemplate = [];
appointments.sliderInnerTemplate = [];
appointments.selectedDressCountContainer = [];
appointments.contactInfo = {};
appointments.dressCategories = [{
    title: "A Line",
    handle: "a-line-wedding-dresses",
  },
  {
    title: "Ballgown",
    handle: "app-ballgown",
  },
  {
    title: "Fit and Flare",
    handle: "fit-and-flare-wedding-dresses",
  },
  {
    title: "Mermaid",
    handle: "mermaid-wedding-dresses",
  },
  {
    title: "Sheath",
    handle: "sheath-wedding-dresses",
  },
];
appointments.locale = "US";
appointments.zip = "";
appointments.firstName = "";
appointments.lastName = "";
appointments.email = "";
appointments.phoneNumber = "";
appointments.whatDays = "";
appointments.whatTimes = "";
appointments.selectedStore = "";
appointments.step = 1;
appointments.selectedDressCount = 0;
appointments.selectedDressesInfo = [];
appointments.animating = false;
appointments.requestInProgress = false;
appointments.errorModal = [];
appointments.errors = {
  zip: {
    message: theme.bookAppointment.zip.message,
    ctaText: theme.bookAppointment.zip.ctaText,
    ctaURL: theme.bookAppointment.zip.ctaURL,
  },
  carousel: {
    message: theme.bookAppointment.carousel.message,
    ctaText: theme.bookAppointment.carousel.ctaText,
    ctaURL: theme.bookAppointment.carousel.ctaURL,
  },
  email: {
    message: theme.bookAppointment.email.message,
    ctaText: theme.bookAppointment.email.ctaText,
    ctaURL: theme.bookAppointment.email.ctaURL,
  },
};

appointments.validateZip = function () {
  var CA = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
  var US = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
  var UK = /[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/gi;

  var valid = false;
  if (appointments.locale == "US") {
    valid = US.test(appointments.zip);
  } else {
    valid = appointments.zip !== "";
  }
  // else if(appointments.locale == "CA") {
  //   valid = CA.test(appointments.zip);
  // }
  // else if(appointments.locale == "UK") {
  //   valid = UK.test(appointments.zip);
  // }
  return valid;
};

appointments.generateLocations = function () {
  if (appointments.stores.length > 0) {
    jQuery(appointments.storeLocationsContainer).html("");
    var city = appointments.stores[0].city;
    var postal_code = appointments.stores[0].postal_code;
    jQuery(appointments.locationList)
      .find("[data-attribute='locations-near-city']")
      .text(city);
    jQuery(appointments.locationList)
      .find("[data-attribute='locations-near-zip']")
      .text(postal_code);
    jQuery.each(appointments.stores, function (k, v) {
      var storeLocation = new StoreLocation(v);
      jQuery(appointments.storeLocationsContainer).append(storeLocation.html);
    });
    appointments.showLocationList();
  } else {
    console.error("No stores found.");
    appointments.showError(appointments.errors.zip);
  }
};

appointments.searchLocations = function () {
  if (appointments.locale) {
    if (appointments.validateZip() && appointments.requestInProgress == false) {
      jQuery(appointments.container).find("#zip-error").hide();
      appointments.toggleLoadingState(appointments.searchButton);
      jQuery(appointments.zipInput).css("border-bottom", "1px solid #313235");
      appointments.requestInProgress = true;
      var url = "https://adrianna-papell.uc.r.appspot.com/closestLocation";
      jQuery
        .ajax({
          url: url,
          type: "GET",
          crossDomain: true,
          dataType: "jsonp",
          data: {
            zipCode: appointments.zip,
            distance: "50",
          },
        })
        .done(function (response) {
          appointments.requestInProgress = false;
          if (!response.body.error) {
            appointments.stores = response.body;
            // Mock data
            appointments.generateLocations();
            appointments.toggleLoadingState(appointments.searchButton);
          } else {
            appointments.toggleLoadingState(appointments.searchButton);
            appointments.showError(appointments.errors.zip);
            console.error("Failed to search stores.");
          }
        })
        .fail(function (response) {
          appointments.requestInProgress = false;
          appointments.toggleLoadingState(appointments.searchButton);
          appointments.showError(appointments.errors.zip);
          console.error("Failed to search stores.");
        });
    } else {
      // invalid zip
      jQuery(appointments.zipInput).css("border-bottom", "1px solid red");
      jQuery(appointments.container).find("#zip-error").show();
    }
  } else {
    // select locale first
  }
};

appointments.showError = function (data) {
  console.log(data);
  if (data.message) {
    jQuery(appointments.errorModal)
      .find("[data-attribute='alert-title']")
      .text(data.message);
  }
  if (data.ctaText && data.ctaURL) {
    jQuery(appointments.errorModal).find("[data-attribute='alert-cta']").show();
    jQuery(appointments.errorModal)
      .find("[data-attribute='alert-cta']")
      .text(data.ctaText)
      .attr("href", data.ctaURL);
  } else {
    jQuery(appointments.errorModal).find("[data-attribute='alert-cta']").hide();
  }
  jQuery(appointments.errorModal).addClass("active");
};

appointments.closeError = function () {
  jQuery(appointments.errorModal).removeClass("active");
};

appointments.animateIn = function (element) {
  jQuery(element).css("display", "block");
  var height = jQuery(appointments.container)
    .find(".book-appointment")
    .height();
  jQuery(appointments.container).animate({
    "min-height": height
  }, {
    duration: 300,
  });
  return jQuery(element).animate({
    opacity: 1
  }, {
    duration: 300,
    complete: function () {
      return true;
    },
  });
};

appointments.animateOut = function (element) {
  var height = jQuery(appointments.container)
    .find(".book-appointment")
    .height();
  jQuery(appointments.container).animate({
    "min-height": height
  }, {
    duration: 300,
  });
  return jQuery(element).animate({
    opacity: 0
  }, {
    duration: 300,
    complete: function () {
      jQuery(element).css("display", "none");
      return true;
    },
  });
};

appointments.showBookView = function () {
  if (!appointments.animating) {
    appointments.animating = true;
    jQuery(appointments.expectButton).removeClass(
      "book-appointment-mainlink-active"
    );
    jQuery(appointments.bookButton).addClass(
      "book-appointment-mainlink-active"
    );
    jQuery
      .when(appointments.animateOut(appointments.expectTab))
      .done(function () {
        jQuery
          .when(appointments.animateIn(appointments.bookTab))
          .done(function () {
            appointments.animating = false;
          });
      });
  }
};

appointments.showExpectView = function () {
  if (!appointments.animating) {
    appointments.animating = true;
    jQuery(appointments.bookButton).removeClass(
      "book-appointment-mainlink-active"
    );
    jQuery(appointments.expectButton).addClass(
      "book-appointment-mainlink-active"
    );
    jQuery
      .when(appointments.animateOut(appointments.bookTab))
      .done(function () {
        jQuery
          .when(appointments.animateIn(appointments.expectTab))
          .done(function () {
            appointments.animating = false;
          });
      });
  }
};

appointments.showLocationList = function (flag) {
  if (!appointments.animating) {
    var target = appointments.locationSearch;
    // Shoddy handler for navigating backwards from the contact form
    if (flag) {
      target = appointments.contactForm;
      appointments.hideContactFooter();
    }
    appointments.animating = true;
    jQuery.when(appointments.animateOut(target)).done(function () {
      jQuery
        .when(appointments.animateIn(appointments.locationList))
        .done(function () {
          appointments.animating = false;
        });
    });
  }
};

appointments.showLocationSearch = function () {
  if (!appointments.animating) {
    appointments.animating = true;
    jQuery
      .when(appointments.animateOut(appointments.locationList))
      .done(function () {
        jQuery
          .when(appointments.animateIn(appointments.locationSearch))
          .done(function () {
            appointments.animating = false;
          });
      });
  }
};

appointments.showContactForm = function (flag) {
  if (!appointments.animating) {
    jQuery(appointments.contactForm)
      .find("[data-attribute='location-name']")
      .text(appointments.selectedStore);
    var target = appointments.locationList;
    // Shoddy handler for navigating backwards from the contact form
    if (flag) {
      target = appointments.selectDresses;
    }
    appointments.animating = true;
    jQuery.when(appointments.animateOut(target)).done(function () {
      appointments.showContactFooter();
      jQuery
        .when(appointments.animateIn(appointments.contactForm))
        .done(function () {
          appointments.animating = false;
          jQuery("html, body").animate({
            scrollTop: 0
          }, 300);
          appointments.destroySliders();
        });
    });
  }
};

appointments.getFormattedJsonResponse = function (
  response,
  collectionHandle,
  collectionTitle
) {
  var collectionData = {};
  collectionData[collectionHandle] = [];
  if (response.data.collectionByHandle != null) {
    jQuery.each(response.data.collectionByHandle.products.edges, function (
      pIndex,
      pValue
    ) {
      var tempObj = {};
      var decodedProductId = atob(pValue.node.id);
      var productIdSplit = decodedProductId.split("/");
      tempObj.cursor = pValue.cursor;
      tempObj.id = productIdSplit[productIdSplit.length - 1];
      tempObj.title = pValue.node.title;
      tempObj.productType = pValue.node.productType;
      tempObj.productType = pValue.node.productType;

      var imageObj = {};
      var imageArray = [];

      jQuery.each(pValue.node.images.edges, function (eIndex, eValue) {
        imageObj = {};
        imageObj.src = eValue.node.originalSrc;
        imageArray.push(imageObj);
      });

      tempObj.images = imageArray;
      collectionData[collectionHandle].push(tempObj);
      collectionData[collectionHandle]["title"] = collectionTitle;
    });
  }
  return collectionData;
};

appointments.apiCall = function (query) {
  return fetch("https://adrianna-papell-usd.myshopify.com/api/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/graphql",
      "X-Shopify-Storefront-Access-Token": "1d3a263e74f8563fd4337df8a3296be1",
    },
    body: query,
  }).then(function (response) {
    return response.json();
  });
};

appointments.getProductByCollection = function (
  collection_handle,
  cursor_token,
  product_direction
) {
  if (!collection_handle) {
    return false;
  }
  const collectionHandle = collection_handle;
  const cursorToken = cursor_token ? '"' + cursor_token + '"' : null;
  const productCount = 8;
  const productListDirection = product_direction;
  let cursorPage = '';
  let query = null;

  if (productListDirection == "next" || !productListDirection) {
    cursorPage = 'after';
  } else if (productListDirection == "previous") {
    cursorPage = 'before';
  }

  query = `query { collectionByHandle(handle:"${collectionHandle}")
  { products(first:${productCount},${cursorPage}:${cursorToken})
   { edges
    { cursor
      node {
        id
        title
        images(first: 1) {
          edges {
            node {
              originalSrc
            }
          }
        }
      }
    }
    pageInfo
    { 
      hasNextPage
      hasPreviousPage
    }
   }
  }
}`;

  var responseData = appointments.apiCall(query).then(function (response) {
    return response;
  });
  return responseData;
}

appointments.generateSliders = function (collectionData, initialize) {
  if (!collectionData) {
    return false;
  }
  var outerTemplate = jQuery(appointments.sliderTemplate).clone();
  var target = jQuery(outerTemplate).find(
    "[data-attribute='image-dress-slider']"
  );
  jQuery.each(collectionData, function (key, value) {
    jQuery(outerTemplate)
      .find("[data-attribute='collection-name']")
      .text(value.title);
    jQuery.each(value, function (innerKey, innerValue) {
      var innerTemplate = jQuery(appointments.sliderInnerTemplate).clone(true);
      if (innerValue.images.length !== 0) {
        var imageSrc = theme.Images.getSizedImageUrl(innerValue.images[0].src, "medium");
        if (!imageSrc) {
          imageSrc = innerValue.images[0].src;
        }
        jQuery(innerTemplate)
          .find("[data-attribute='product-image']")
          .attr("src", imageSrc);
      }
      jQuery(innerTemplate)
        .find("[data-attribute='product-name']")
        .text(innerValue.title);
      jQuery(innerTemplate).attr("product-id", innerValue.id);

      jQuery(target).append(innerTemplate);
    });
  });
  jQuery(appointments.sliderContainer).append(outerTemplate);
  if (initialize == true) {
    // Small initilization latency fix
    setTimeout(function () {
      appointments.bindSliders();
    }, 200);

  }
};

appointments.bindSliders = function () {
  jQuery(appointments.sliderContainer).find(".spinning-loader").remove();
  jQuery(".image-dress-slider").slick({
    dots: false,
    infinite: false,
    speed: 300,
    arrow: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 2,
          infinite: true,
          arrows: false,
          centerMode: true,
          centerPadding: "25px",
          slidesToScroll: 1,
        },
      },
    ],
  });
};

appointments.destroySliders = function () {
  if (jQuery(appointments.sliderContainer).children().length > 0) {
    jQuery(".image-dress-slider").slick("unslick");
  }
  jQuery(appointments.sliderContainer).html(
    "<span class='spinning-loader'></span>"
  );
};

appointments.updateSelectedDresses = function () {
  appointments.selectedDressCount = 0;
  appointments.selectedDressesInfo = [];
  var slides = jQuery(appointments.sliderContainer).find("label");
  jQuery(appointments.selectedDresses).find("[product-id]").remove();
  jQuery.each(slides, function (k, v) {
    if (jQuery(v).hasClass("active")) {
      appointments.selectedDressCount++;
      var obj = {};
      obj.productID = jQuery(v).attr("product-id");
      obj.productImage = jQuery(v).find("img").attr("src");
      obj.productName = jQuery(v)
        .find("[data-attribute='product-name']")
        .text();
      appointments.selectedDressesInfo.push(obj);
      var template = jQuery(appointments.selectedImageTemplate).clone(true);
      jQuery(template)
        .find("[data-attribute='selected-image']")
        .attr("src", obj.productImage);
      jQuery(template).attr("product-id", obj.productID);
      jQuery(appointments.selectedDresses).prepend(template);
    }
  });
  jQuery(appointments.selectedDressCountContainer).text(
    appointments.selectedDressCount
  );
};

appointments.removeDress = function (object) {
  var productId = jQuery(object).attr("product-id");
  appointments.selectedDressCount--;
  jQuery(appointments.sliderContainer)
    .find("[product-id='" + productId + "']")
    .removeClass("active")
    .find("input")
    .prop("checked", false);
  appointments.updateSelectedDresses();
};

appointments.fetchDressCollections = function () {
  var initialize = false;
  var length = appointments.dressCategories.length - 1;
  jQuery.each(appointments.dressCategories, function (k, v) {
    var cursor_token = null;
    var product_direction = "next";
    var responseData = appointments.getProductByCollection(
      v.handle,
      cursor_token,
      product_direction
    );
    if (responseData) {
      responseData.then(function (response) {
        if (response.data.collectionByHandle) {
          var collectionData = appointments.getFormattedJsonResponse(
            response,
            v.handle,
            v.title
          );
          if (length == k) {
            initialize = true;
          }
          appointments.generateSliders(collectionData, initialize);
        } else {
          console.error("No collection data returned!");
        }
      });
    }
  });
};

appointments.showDressSelect = function () {
  if (!appointments.animating) {
    appointments.animating = true;
    jQuery(appointments.selectDresses)
      .find("[data-attribute='location-name']")
      .text(appointments.selectedStore);
    jQuery
      .when(appointments.animateOut(appointments.contactForm))
      .done(function () {
        appointments.showContactFooter();
        jQuery
          .when(appointments.animateIn(appointments.selectDresses))
          .done(function () {
            appointments.animating = false;
            jQuery("html, body").animate({
              scrollTop: 0
            }, 300);
            appointments.fetchDressCollections();
          });
      });
  }
};

appointments.showContactFooter = function () {
  appointments.animateIn(appointments.contactFooter);
};

appointments.hideContactFooter = function () {
  appointments.animateOut(appointments.contactFooter);
};

appointments.showBookingConfirmation = function () {
  appointments.hideContactFooter();
  jQuery(appointments.confirmation)
    .find("[data-attribute='confirmation-name']")
    .text(appointments.selectedStore);
  jQuery(appointments.confirmation)
    .find("[data-attribute='your-email']")
    .text(appointments.contactInfo.email);
  if (!appointments.animating) {
    appointments.animating = true;
    jQuery
      .when(appointments.animateOut(appointments.selectDresses))
      .done(function () {
        jQuery
          .when(appointments.animateIn(appointments.confirmation))
          .done(function () {
            appointments.animating = false;
          });
      });
  }
};

appointments.toggleLoadingState = function (button) {
  jQuery(button).toggleClass("disabled");
  jQuery(button).find(".spinning-loader").toggle();
};

appointments.submitContactForm = function () {
  appointments.toggleLoadingState(appointments.submitButton);
  appointments.contactInfo.firstName = jQuery(appointments.contactForm)
    .find("#fname")
    .val();
  appointments.contactInfo.lastName = jQuery(appointments.contactForm)
    .find("#lname")
    .val();
  appointments.contactInfo.email = jQuery(appointments.contactForm)
    .find("#email")
    .val();
  appointments.contactInfo.phoneNumber = jQuery(appointments.contactForm)
    .find("#phone")
    .val();
  appointments.contactInfo.whatDays = [];
  appointments.contactInfo.whatTimes = [];
  appointments.contactInfo.selectedDressesInfo =
    appointments.selectedDressesInfo;
  appointments.contactInfo.storeName = appointments.selectedStore;
  appointments.contactInfo.storeId = appointments.selectedStoreId;
  appointments.contactInfo.dressSize = jQuery(appointments.contactForm).find("#dress-size").val();
  jQuery(appointments.contactForm)
    .find("[data-attribute='what-days']")
    .each(function (k, v) {
      if (jQuery(v).prop("checked") == true) {
        appointments.contactInfo.whatDays.push(jQuery(v).val());
      }
    });
  jQuery(appointments.contactForm)
    .find("[data-attribute='what-times']")
    .each(function (k, v) {
      if (jQuery(v).prop("checked") == true) {
        appointments.contactInfo.whatTimes.push(jQuery(v).val());
      }
    });
  var toMail = appointments.contactInfo.email;
  var fromMail = "stylist@adriannapapellusa.com";
  var emailBody = {};
  emailBody.firstName = appointments.contactInfo.firstName;
  emailBody.lastName = appointments.contactInfo.lastName;
  emailBody.email = appointments.contactInfo.email;
  emailBody.phoneNumber = appointments.contactInfo.phoneNumber;
  emailBody.storeId = appointments.contactInfo.storeId;
  emailBody.storeName = appointments.contactInfo.storeName;
  emailBody.appointmentPreferences = appointments.contactInfo.whatTimes.join(", ") +
    " / " + appointments.contactInfo.whatDays;
  emailBody.dressSize = appointments.contactInfo.dressSize;
  emailBody.selectedImages = "";
  if (appointments.contactInfo.selectedDressesInfo.length > 0) {
    jQuery.each(appointments.contactInfo.selectedDressesInfo, function (k, v) {
      emailBody.selectedImages += '<div class="image-wrap__select"><img src="https:' + v.productImage +
        '" alt="' + v.productName + '" /><div class="number">' + v.productName + '</div></div>';
    });
  } else {
    emailBody.selectedImages = "No styles selected.";
  }

  if (toMail && fromMail && emailBody) {
    jQuery.ajax({
      type: "POST",
      crossDomain: true,
      url: "https://us-central1-adrianna-papell.cloudfunctions.net/sendGridAppointmentSubmission",
      dataType: "json",
      data: {
        to: toMail,
        from: fromMail,
        body: emailBody
      },
      success: function (response) {
        appointments.toggleLoadingState(appointments.submitButton);
        appointments.showBookingConfirmation();
      },
      error: function (errorMsg) {
        appointments.toggleLoadingState(appointments.submitButton);
        appointments.showError(appointments.errors.mail);
        console.log(errorMsg.message);
      },
    });
  }

  jQuery("html, body").animate({
    scrollTop: 0
  }, 300);
};

appointments.bind = function () {
  jQuery(appointments.bookButton).on("click", function (e) {
    e.preventDefault();
    appointments.showBookView();
  });
  jQuery(appointments.expectButton).on("click", function (e) {
    e.preventDefault();
    appointments.showExpectView();
  });
  jQuery(appointments.searchButton).on("click", function (e) {
    e.preventDefault();
    appointments.searchLocations();
  });
  jQuery(appointments.zipInput).on("keyup", function () {
    var val = jQuery(this).val();
    appointments.zip = val;
  });
  jQuery(appointments.localeSwitch).on("change", function () {
    var val = jQuery(this).val();
    appointments.locale = val;
  });
  jQuery(appointments.changeLocationButton).on("click", function (e) {
    e.preventDefault();
    appointments.showLocationSearch();
  });
  jQuery(appointments.nextStep).on("click", function (e) {
    e.preventDefault();
    jQuery('#RequestAppointmentFormSubmit').trigger('click');
  });
  jQuery(appointments.contactFooter)
    .find("[data-attribute='previous-step']")
    .on("click", function (e) {
      e.preventDefault();
      jQuery(appointments.submitButton).hide();
      jQuery(appointments.nextStep).css("display", "inline-block");
      if (appointments.step == 2) {
        appointments.step--;
        appointments.showContactForm(true);
        jQuery(appointments.selectedDresses).hide();
      } else {
        appointments.showLocationList(true);
      }
      jQuery(appointments.contactFooter)
        .find("[data-attribute='current-step']")
        .text(appointments.step);
    });
  jQuery(appointments.submitButton).on("click", function (e) {
    e.preventDefault();
    appointments.submitContactForm();
  });
  jQuery(appointments.sliderInnerTemplate).on("click", function (e) {
    // Our label in the markup is wrapping the input element instead of using the `for=[id]` and living beside it (which is more proper)
    // This causes a duplicate click event to be created from the browser (the label creating a click event on the child radio input)
    // preventDefault() stops this from happening, and then we later manually set the radio buttons checked prop to true
    e.preventDefault();
    if (jQuery(this).find("input").prop("checked") == true) {
      appointments.selectedDressCount--;
      jQuery(this).removeClass("active");
      jQuery(this).find("input").prop("checked", false);
    } else {
      if (appointments.selectedDressCount < 3) {
        appointments.selectedDressCount++;
        jQuery(this).addClass("active");
        jQuery(this).find("input").prop("checked", true);
      }
    }
    appointments.updateSelectedDresses();
  });
  jQuery(appointments.selectedImageTemplate).on("click", function () {
    var object = jQuery(this);
    appointments.removeDress(object);
  });
  jQuery(appointments.errorModal)
    .find("[data-attribute='close-modal']")
    .on("click", function () {
      appointments.closeError();
    });
};

appointments.init = function () {
  appointments.container = jQuery("[data-attribute='appointments']");
  if (appointments.container.length > 0) {
    appointments.navigation = jQuery(appointments.container).find(
      "[data-attribute='navigation']"
    );
    appointments.bookButton = jQuery(appointments.navigation).find(
      "[data-attribute='book']"
    );
    appointments.expectButton = jQuery(appointments.navigation).find(
      "[data-attribute='expect']"
    );
    appointments.searchButton = jQuery(appointments.container).find(
      "[data-attribute='search']"
    );
    appointments.zipInput = jQuery(appointments.container).find(
      "[data-attribute='zip']"
    );
    appointments.localeSwitch = jQuery(appointments.container).find(
      "[data-attribute='locale']"
    );
    appointments.bookTab = jQuery(appointments.container).find(
      "[data-attribute='book-appointment']"
    );
    appointments.expectTab = jQuery(appointments.container).find(
      "[data-attribute='what-to-expect']"
    );
    appointments.locationList = jQuery(appointments.container).find(
      "[data-attribute='location-list']"
    );
    appointments.locationSearch = jQuery(appointments.container).find(
      "[data-attribute='location-search']"
    );
    appointments.changeLocationButton = jQuery(appointments.container).find(
      "[data-attribute='change-location']"
    );
    appointments.contactForm = jQuery(appointments.container).find(
      "[data-attribute='request-appointment']"
    );
    appointments.contactFooter = jQuery(appointments.container).find(
      "[data-attribute='request-appointment-footer']"
    );
    appointments.nextStep = jQuery(appointments.contactFooter).find(
      "[data-attribute='next-step']"
    );
    appointments.submitButton = jQuery(appointments.contactFooter).find(
      "[data-attribute='submit-contact']"
    );
    appointments.selectDresses = jQuery(appointments.container).find(
      "[data-attribute='select-dresses']"
    );
    appointments.selectedDresses = jQuery(appointments.contactFooter).find(
      "[data-attribute='selected-dresses']"
    );
    appointments.sliderContainer = jQuery(appointments.container).find(
      "[data-attribute='slider-container']"
    );
    appointments.sliderTemplate = jQuery(appointments.container)
      .find("[data-attribute='slick-template']")
      .clone()
      .removeClass("template")
      .removeAttr("data-attribute");
    appointments.sliderInnerTemplate = jQuery(appointments.container)
      .find("[data-attribute='slick-inner-template']")
      .clone()
      .removeClass("template")
      .removeAttr("data-attribute");
    appointments.storeLocationTemplate = jQuery(appointments.container)
      .find("[data-attribute='store-location-template']")
      .clone()
      .removeAttr("store-location-template")
      .removeClass("template");
    appointments.storeLocationsContainer = jQuery(appointments.container).find(
      "[data-attribute='store-locations-list']"
    );
    appointments.selectedImageTemplate = jQuery(appointments.container)
      .find("[data-attribute='selected-image-template']")
      .clone()
      .removeClass("template")
      .removeAttr("data-attribute");
    appointments.selectedDressCountContainer = jQuery(
      appointments.container
    ).find("[data-attribute='selected-dresses-count']");
    appointments.confirmation = jQuery(appointments.container).find(
      "[data-attribute='appointment-confirmation']"
    );
    appointments.errorModal = jQuery(appointments.container).find(
      "[data-attribute='alert-modal']"
    );
    appointments.bind();
  } else {
    console.error("Unable to initialize.");
  }
};

function StoreLocation(data) {
  this.address1 = data.address1;
  this.city = data.city;
  this.country_code = data.country_code;
  this.created_at = data.created_at;
  this.distance = data.distance;
  this.id = data.id;
  this.latitude = data.latitude;
  this.longitude = data.longitude;
  this.name = data.name;
  this.postal_code = data.postal_code;
  this.province = data.province_code;
  this.store = data.store;
  this.store_id = data.store_id.toString().padStart(3, '0');
  this.updated_at = data.updated_at;
  this.hasImage = data.image;
  this.imageThumbnail = "https://cdn.shopify.com/s/files/1/0408/4583/6453/files/" + this.store_id + "-platinum.png";
  this.generateHTML();
  this.bind();
}
StoreLocation.prototype.generateHTML = function () {
  this.html = jQuery(appointments.storeLocationTemplate).clone();


  if (this.hasImage == 'x') {
    jQuery(this.html).find("[data-attribute='location-image']").attr("src", this.imageThumbnail);
    jQuery(this.html).find("[data-attribute='location-image']").attr('alt', this.name);
  } else {
    jQuery(this.html).find("[data-attribute='location-image']").hide();
  }

  jQuery(this.html).find("[data-attribute='location-title']").text(this.name);
  jQuery(this.html).find("[data-attribute='location-province']").text(this.province);
  jQuery(this.html)
    .find("[data-attribute='location-address']")
    .text(this.address1);
  jQuery(this.html).find("[data-attribute='location-city']").text(this.city);
  jQuery(this.html)
    .find("[data-attribute='location-zip']")
    .text(this.postal_code);
};
StoreLocation.prototype.bind = function () {
  var store = this;
  jQuery(store.html)
    .find("[data-attribute='location-book']")
    .on("click", function (e) {
      e.preventDefault();
      store.showContactForm();
    });
};
StoreLocation.prototype.showContactForm = function () {
  appointments.selectedStore = this.name;
  appointments.selectedStoreId = this.store_id;
  appointments.showContactForm();
};

window.addEventListener("DOMContentLoaded", function () {
  appointments.init();

  // view more
  $(".view_more").on("click", function () {
    $(".book-appointment-qa-content__right").slideToggle("slow");
    $(".view_more").toggleClass("active");
  });

  var RequestAppointmentForm = document.getElementById("RequestAppointmentForm");

  // create the pristine instance
  var pristine = new Pristine(RequestAppointmentForm);

  RequestAppointmentForm.addEventListener('submit', function (e) {
    e.preventDefault();
    // check if the form is valid
    var valid = pristine.validate(); // returns true or false

    if (!valid) {
      return;
    } else {
      if (appointments.step < 2) {
        appointments.step++;
        jQuery(appointments.nextStep).hide();
        jQuery(appointments.submitButton).css("display", "inline-block");
        jQuery(appointments.selectedDresses).css("display", "flex");
        jQuery(appointments.contactFooter)
          .find("[data-attribute='current-step']")
          .text(appointments.step);
        appointments.showDressSelect();
      }
    }
  });
});
